import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Teleport as _Teleport } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TrainingPlanEdit = _resolveComponent("TrainingPlanEdit")!
  const _component_oxd_dialog = _resolveComponent("oxd-dialog")!

  return (_openBlock(), _createBlock(_Teleport, { to: "#app" }, [
    ($data.show)
      ? (_openBlock(), _createBlock(_component_oxd_dialog, {
          key: 0,
          style: {"max-width":"1150px"},
          "onUpdate:show": $options.onCancel
        }, {
          default: _withCtx(() => [
            _createVNode(_component_TrainingPlanEdit, {
              departments: $props.departments,
              "is-modal": true,
              onOnCancel: $options.onCancel,
              onAfterSubmit: $options.afterSubmit
            }, null, 8, ["departments", "onOnCancel", "onAfterSubmit"])
          ]),
          _: 1
        }, 8, ["onUpdate:show"]))
      : _createCommentVNode("", true)
  ]))
}